import React from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
  Input,
  Label,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Row,
  Col,
  CardFooter
} from "reactstrap";
// react plugin used to create datetimepicker
import Datetime from "react-datetime";
// react plugin used to create switch buttons
import Switch from "react-bootstrap-switch";
// react plugin used to create DropdownMenu for selecting items
import Select from "react-select";
// react plugin that creates an input with badges
import TagsInput from "react-tagsinput";
// plugin that creates slider
import Slider from "nouislider";
import { Redirect } from "react-router-dom";

import { PanelHeader, ImageUpload, Progress, Button } from "components";
// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import HomeVisitsList from "./HomeVisitsList";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";

import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker
} from "react-google-maps";
import moment from "moment";
import "moment/locale/es";

const RegularMap = withScriptjs(
  withGoogleMap(props => (
    <GoogleMap
      defaultZoom={16}
      defaultCenter={{ lat: 39.653328, lng: -0.427402 }}
      defaultOptions={{
        scrollwheel: false
      }}
      center={{ lat: props.latitude, lng: props.longitude }}
      mapTypeId={"satellite"}
    >
      {props.latitude && (
        <Marker position={{ lat: props.latitude, lng: props.longitude }} />
      )}
    </GoogleMap>
  ))
);

var selectOptions = [
  { value: "one", label: "One" },
  { value: "two", label: "Two" },
  { value: "three", label: "Three" },
  { value: "four", label: "Four" },
  { value: "five", label: "Five" },
  { value: "six", label: "Six" }
];

class NewHomeVisit extends React.Component {
  constructor(props) {
    super(props);
    let selectedCustomer = null;
    let address = null;
    if (this.props.mainState.existingCustomerForHomeVisit) {
      let prevCustomer = this.props.mainState.existingCustomerForHomeVisit.customer;
      // console.log("existing customer", prevCustomer);
      selectedCustomer = {
        value: this.props.mainState.existingCustomerForHomeVisit.id,
        label: prevCustomer.nombre_completo + " " + prevCustomer.primer_apellido + " " + prevCustomer.segundo_apellido + " (" + prevCustomer.nif + ")"
      };
      address = prevCustomer.domicilio + ", " + prevCustomer.localidad;
    }
    let isCreateFromCalendar = this.props.mainState.homeVisitFromCalendar;
    this.state = {
      isEdit: window.location.pathname.includes("citas/editar"),
      isEditingLoaded: false,
      selectedCustomer: selectedCustomer,
      multipleSelect: null,
      singleFileName: "",
      multipleFileName: "",
      singleFile: null,
      multipleFile: null,
      regularTags: ["pizza", "pasta", "parmesan"],
      searchQuery: null,
      lastSearchedQuery: null,
      lastLoadedCustomersSearch: null,
      technicians: null,
      goTo: null,
      address: address ? address : (isCreateFromCalendar ? (isCreateFromCalendar.address ? isCreateFromCalendar.address : "") : ""),
      addressObject: null,
      title: isCreateFromCalendar ? isCreateFromCalendar.title: "",
      date_hour: isCreateFromCalendar ? isCreateFromCalendar.date : null,
      date_day: isCreateFromCalendar ? isCreateFromCalendar.date : null,
      duration: 2,
      relatedServiceContract: null,
      hasContract: false,
      relatedServiceContractList: []
    };
    if (this.state.isEdit) this.state.homeVisitId = parseInt(this.props.match.params.homeVisit);
    this.handleRegularTags = this.handleRegularTags.bind(this);
    this.handleFileInput = this.handleFileInput.bind(this);
    this.searchCustomerReference = this.searchCustomerReference.bind(this);
    this.getCustomerReferences = this.getCustomerReferences.bind(this);
    this.validateNewHomeVisit = this.validateNewHomeVisit.bind(this);
    this.createHomeVisit = this.createHomeVisit.bind(this);
    this.handleChangeAddress = this.handleChangeAddress.bind(this);
    this.handleSelectAddress = this.handleSelectAddress.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
    this.goBack = this.goBack.bind(this);
    this.getRelatedContracts = this.getRelatedContracts.bind(this);
  }
  componentDidMount() {
    this.props.userData.createHomeVisitFromCalendar(null);
    this.props.userData.setExistingCustomerForHomeVisit(null);
    this.props.userData.getTechniciansList();
    this.props.userData.getHomeVisitTypesList();
    if (this.state.isEdit) this.props.getHomeVisit(this.state.homeVisitId);
    // var slider1 = this.refs.slider1;
    // var slider2 = this.refs.slider2;
    // Slider.create(slider1, {
    //   start: [40],
    //   connect: [true, false],
    //   step: 1,
    //   range: { min: 0, max: 100 }
    // });
    // Slider.create(slider2, {
    //   start: [20, 60],
    //   connect: [false, true, false],
    //   step: 1,
    //   range: { min: 0, max: 100 }
    // });
  }
  handleChangeAddress = address => {
    console.log("address", address);
    this.setState({ address });
    this.setState({ street: address });
  };
  handleSelectAddress = (address, placeId, suggestion) => {
    if (suggestion) {
      // console.log(suggestion);
      this.setState({
        address: address,
        street: suggestion.formattedSuggestion.mainText,
        addressObject: suggestion,
        locality: suggestion.terms[suggestion.terms.length - 2].value
      });
      geocodeByAddress(address)
        .then(results => getLatLng(results[0]))
        .then(latLng => {
          // console.log("Success", latLng);
          this.setState({
            latitude: latLng.lat,
            longitude: latLng.lng
          });
        })
        .catch(error => console.error("Error", error));
    } else {
      this.setState({
        address: address,
        street: "",
        addressObject: null,
        locality: "",
        latitude: null,
        longitude: null
      });
    }
  };
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  goBack() {
    window.history.back();
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    // console.log("UPDATE NUEVA CITA", this.state);
    if (!this.props.mainState.isGettingTechnicians && (!this.props.mainState.techniciansList || this.props.mainState.techniciansList.length === 0)) {
      if (!window.location.host.includes("localhost")) this.props.userData.getTechniciansList();
    }
    if (this.state.lastLoadedCustomersSearch !== this.state.lastSearchedQuery) {
      if (this.state.lastSearchedQuery in this.props.mainState.customerSearchReference) {
        this.setState({ 
          customersReferences: this.props.mainState.customerSearchReference[this.state.lastSearchedQuery].references,
          lastLoadedCustomersSearch: this.state.lastSearchedQuery
        });
      }
    }
    if (prevProps.mainState.isCreatingHomeVisit && !this.props.mainState.isCreatingHomeVisit && !this.props.mainState.isErrorCreatingHomeVisit) {
      this.setState({ goTo: "/citas" });
    }
    if (prevProps.mainState.isEditingHomeVisit && !this.props.mainState.isEditingHomeVisit && !this.props.mainState.isErrorEditingHomeVisit) {
      this.redirectTo("/citas/" + this.state.homeVisitId);
    }
    if (this.state.isEdit && !this.state.isEditingLoaded) {
      if (this.props.state.homeVisits && this.props.state.homeVisits.byId) {
        let homeVisit = this.props.state.homeVisits.byId[this.state.homeVisitId][0];
        // console.log("HOME VISIT LOADED", homeVisit);
        this.setState({
          isEditingLoaded: true,
          title: homeVisit.title,
          date_hour: moment(homeVisit.visit_date_hour, "hh:mm"),
          date_day: moment(homeVisit.visit_date_day, "DD/MM/YYYY"),
          address: homeVisit.visit_address + ", " + homeVisit.visit_locality,
          street: homeVisit.visit_address,
          longitude: homeVisit.longitude,
          latitude: homeVisit.latitude,
          description: homeVisit.description,
          visit_type: {
            value: parseInt(homeVisit.visit_type.tid),
            label: homeVisit.visit_type_name
          },
          locality: homeVisit.visit_locality,
          selectedCustomer: {
            value: parseInt(homeVisit.customer.id),
            label: homeVisit.customer.name
          },
          technicians: homeVisit.assigned_technician.map(technician => {
            return {
              value: technician.id,
              label: technician.username
            };
          }),
          duration: homeVisit.expected_duration,
          hasContract: homeVisit.has_contract,
          relatedServiceContract: homeVisit.related_contract
        });
        // console.log("homeVisit cargado", homeVisit);
      }
    }
    // console.log("this.props.state", this.props.state);
  }
  handleRegularTags(regularTags) {
    this.setState({ regularTags });
  }
  // // // to understand the bellow functions please take a look at the end of the document as well
  // this handles the onFocus event over the normal / visible Inputs (reactstrap components)
  // that will trigger the on click of the non-visible inputs (normal html component)
  handleFileInput(e, type) {
    this.refs[type].click(e);
  }
  // this is the function triggered for the file type input
  // it will store inside the components state the names of the files and the files
  // after that, if you want to save the files you need to add a special on submit function for that
  // we haven't since we do not need to save the files - everything in our product is only front-end
  addFile(e, type) {
    let fileNames = "";
    let files = e.target.files;
    for (let i = 0; i < e.target.files.length; i++) {
      fileNames = fileNames + e.target.files[i].name;
      if (type === "multipleFile" && i !== e.target.files.length - 1) {
        fileNames = fileNames + ", ";
      }
    }
    this.setState({
      [type + "Name"]: fileNames,
      [type]: files
    });
  }
  searchCustomerReference() {
    this.props.userData.searchCustomerReference(this.state.searchQuery);
    this.setState({ lastSearchedQuery: this.state.searchQuery });
  }
  getCustomerReferences() {
    if (this.state.searchQuery === null || this.state.searchQuery === "") return null;
    if (this.state.searchQuery in this.props.mainState.customerSearchReference) {
      return this.props.mainState.customerSearchReference[this.state.searchQuery].references;
    } else {
      return null;
    }
  }
  validateNewHomeVisit() {
    let result = true;
    if (!this.state.selectedCustomer) result = false;
    if (!this.state.title || (this.state.title && this.state.title.length < 2)) result = false;
    if (!this.state.date_day) result = false;
    if (!this.state.date_hour) result = false;
    if (!this.state.locality || (this.state.locality && this.state.locality.length < 2)) result = false;
    if (!this.state.street || (this.state.street && this.state.street.length < 2)) result = false;
    if (!this.state.visit_type) result = false;
    if (!this.state.technicians) result = false;
    if (!this.state.latitude) result = false;
    if (!this.state.longitude) result = false;
    if (!this.state.duration) result = false;
    if (this.state.selectedCustomer && this.state.hasContract && !this.state.relatedServiceContract) result = false;
    // if (!this.state.description) result = false;
    // console.log("##### STATE EN CHECK HOME VISIT ######");
    // console.log(this.state);

    return result;
  }
  createHomeVisit() {
    if (this.validateNewHomeVisit()) {
      let homeVisit = {
        title: this.state.title,
        date: this.state.date_day.format("YYYY-MM-DD") + " " + this.state.date_hour.format("HH:mm"),
        description: this.state.description,
        visit_type: parseInt(this.state.visit_type.value),
        technicians: this.state.technicians,
        customer: this.state.selectedCustomer ? this.state.selectedCustomer.value : 635,
        locality: this.state.locality,
        street: this.state.street,
        latitude: this.state.latitude,
        longitude: this.state.longitude,
        duration: this.state.duration
      };
      if (this.state.hasContract)
        homeVisit.related_contract = this.state.relatedServiceContract.value;
      // console.log("NUEVA HOME VISIT", homeVisit);
      this.props.userData.createHomeVisit(homeVisit);
    }
  }
  editHomeVisit() {
    if (this.validateNewHomeVisit()) {
      console.log("STATE EDITAR", this.state);
      let homeVisit = {
        id: this.state.homeVisitId,
        title: this.state.title,
        date: this.state.date_day.format("YYYY-MM-DD") + " " + this.state.date_hour.format("HH:mm"),
        duration: this.state.duration,
        description: this.state.description,
        visit_type: parseInt(this.state.visit_type.value),
        technicians: this.state.technicians,
        customer: this.state.selectedCustomer ? this.state.selectedCustomer.value : 635,
        locality: this.state.locality,
        street: this.state.street,
        latitude: this.state.latitude,
        longitude: this.state.longitude
      };
      if (this.state.hasContract)
        homeVisit.related_contract = this.state.relatedServiceContract.value;
      // console.log("EDITAR HOME VISIT", homeVisit);
      this.props.userData.editHomeVisit(homeVisit);
    }
  }
  prepareCustomersOptions(customersReferences) {
    if (!customersReferences) customersReferences = [];
    let nadunetCustomer = [
      {
        label: "nadunet (Trabajos propios)",
        value: 1
      },
      // {
      //   label: "Adrián Duque",
      //   value: 635
      // }
    ];
    customersReferences = nadunetCustomer.concat(customersReferences);
    return customersReferences;
  }
  getRelatedContracts() {
    let isGettingRelatedContracts = this.state.isGettingRelatedContracts;
    this.setState({ isGettingRelatedContracts: isGettingRelatedContracts });
    let customer = this.state.selectedCustomer;
    if (!customer) return;
    let customerID = customer.value;

    this.props.getRelatedContracts(customerID).then(result => {
        /* ////// console.log("################## RESPUESTA ################");
        ////// console.log(result); */
        let isGettingRelatedContracts = this.state.isGettingRelatedContracts;
        let response = result; // result.data;
        let relatedServiceContractList = this.state.relatedServiceContractList;
        if (response.result === "OK") {
          relatedServiceContractList[customerID] = response.contracts;
        } else {
          // this.showError(response.error);
          console.log("Error al obtener los contratos del cliente", response.error);
        }
        this.setState({
          isGettingRelatedContracts: isGettingRelatedContracts,
          relatedServiceContractList: relatedServiceContractList
        });
      })
      .catch((error) => {
        // Error 😨
        this.setState({
          isGettingRelatedContracts: false
        });
        console.log("Error al obtener los contratos del cliente", error);
        // this.showError("Error al obtener los contratos relacionados, vuelve a intentarlo en un momento. (" + error + ")");
      });
  }
  render() {
    if (this.state.goTo) {
      this.redirectTo(this.state.goTo);
      // return <Redirect to={this.state.goTo} />;
    }
    let save_text = "Crear visita";
    let goBackButton = null;
    if (this.state.isEdit) {
      save_text = "Guardar cambios";
      goBackButton = (
        <Button
          color={"default"}
          round 
          // icon 
          // disabled={!this.validateNewHomeVisit()}
          onClick={() => {
            this.goBack();
          }}
        >
          Cancelar
        </Button>
      );
    }
    if (this.state.isEdit && !this.state.isEditingLoaded) {
      return (
        <div>
            <PanelHeader size="sm" />
            <div className="content text-center">
            <Card color="primary" style={{ margin: 0 }}>
                <CardHeader></CardHeader>
                <CardBody className="text-center">
                <div>
                    <div className="text-center">
                    <br />
                    <h5><i className="now-ui-icons arrows-1_refresh-69 spin" /> Cargando</h5>
                    </div>
                </div>
                </CardBody>
                <CardFooter></CardFooter>
            </Card>
            </div>
        </div>
      );
    } else {
      return (
        <div>
          <PanelHeader size="sm" />
          <div className="content">
            <Row>
              <Col xs={12} md={6}>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Cliente</CardTitle>
                  </CardHeader>
                  <CardBody className="form-inline">
                    <Row>
                      <Col xs={12}>
                        <FormGroup>
                          <Input type="text" 
                            placeholder="Buscar cliente..."
                            value={this.state.searchQuery || ""}
                            onChange={(e) => this.setState({searchQuery: e.target.value})}
                            onKeyDown={e => {
                              //console.log(e.keyCode);
                              if(e.keyCode == 13){
                                //Enter is key code 13
                                this.searchCustomerReference();
                                // put the login here
                              }
                            }}
                            style={{marginRight:"10px"}}
                          />
                          <Button
                            color={
                              this.props.mainState.isSearchingBills
                                ? "default"
                                : "primary"
                            }
                            round 
                            icon 
                            disabled={(this.state.searchQuery === null || this.state.searchQuery === "")}
                            onClick={this.searchCustomerReference}>
                            <i className={this.props.mainState.isSearchingHomeVisits?
                                                  "now-ui-icons arrows-1_refresh-69 spin reposition-spin" :"now-ui-icons ui-1_zoom-bold"} />
                          </Button>
                        </FormGroup>
                      </Col>
                      <Col xs={12}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          placeholder="Elegir cliente"
                          name="selectedCustomer"
                          value={this.state.selectedCustomer}
                          options={this.prepareCustomersOptions(this.state.customersReferences)}
                          noOptionsMessage={() => this.state.lastSearchedQuery ? <span>No hay resultados para <b>{this.state.searchQuery}</b></span> : "Busca clientes antes"}
                          onChange={value =>{
                            // console.log("######## CAMBIO CLIENTE ######");
                            // console.log(value);
                            this.setState({ selectedCustomer: value });
                          }}
                        />
                      </Col>
                      {(this.state.selectedCustomer) && 
                        <Col
                          style={{ marginTop: "10px" }} 
                          xs={12}>
                          <FormGroup check className="form-check-inline">
                            <Label check style={{ fontAlign: "left" }}>
                              <Input type="checkbox" checked={this.state.hasContract} onChange={() => {
                                  let hasContract = !this.state.hasContract;
                                  if (!hasContract) {
                                    this.setState({ 
                                      hasContract: hasContract,
                                      relatedServiceContract: null
                                    });
                                  } else {
                                    console.log("this.state.selectedCustomer", this.state.selectedCustomer);
                                    this.getRelatedContracts();
                                    this.setState({ hasContract: hasContract });
                                  }
                                }}/>
                              <span className="form-check-sign" />
                              Existe contrato asociado
                            </Label>
                          </FormGroup>
                        </Col>}
                      {(this.state.selectedCustomer && this.state.hasContract) && 
                      <Col
                          style={{ marginTop: "10px" }} 
                          xs={12}>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          placeholder="Elegir contrato"
                          name="relatedServiceContract"
                          value={this.state.relatedServiceContract}
                          options={this.state.selectedCustomer ? this.state.relatedServiceContractList[this.state.selectedCustomer.value] : null}
                          noOptionsMessage={() => "Sin contratos"}
                          onChange={value =>{
                            // console.log("######## CAMBIO CLIENTE ######");
                            // console.log(value);
                            this.setState({ relatedServiceContract: value });
                          }}
                        />
                      </Col>}
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                  <CardTitle tag="h4">¿Cuándo?</CardTitle>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Día</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Datetime
                        timeFormat={false}
                        inputProps={{ placeholder: "Selecciona el día" }}
                        value={this.state.date_day}
                        onChange={value => {
                          // console.log("cambio día", value);
                          this.setState({ date_day: value });
                        }}
                      />
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
              <Col xs={12} md={4}>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Hora</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Datetime
                        dateFormat={false}
                        inputProps={{ placeholder: "Elige la hora" }}
                        value={this.state.date_hour}
                        onChange={value => {
                          // console.log("cambio hora", value);
                          this.setState({ date_hour: value });
                        }}
                      />
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <CardTitle tag="h4">¿Duración?</CardTitle>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Cuántas horas</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Input
                        type="number"
                        placeholder="Indica la duración en horas"
                        value={this.state.duration || ""}
                        onChange={e => this.setState({ duration: e.target.value })}
                      />
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Col xs={12} md={4}>
                  <CardTitle tag="h4">¿Dónde?</CardTitle>
              </Col>
            </Row>
            <Row>
              {/* <Col xs={12} md={4}>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Localidad</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <Input
                        type="text"
                        placeholder="Náquera"
                        value={this.state.locality || ""}
                        onChange={e =>
                          this.setState({ locality: e.target.value })
                        }
                      />
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col> */}
              <Col xs={12} md={4}>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Dirección</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <FormGroup>
                      <PlacesAutocomplete
                        value={this.state.address}
                        onChange={this.handleChangeAddress}
                        onSelect={this.handleSelectAddress}
                        className="form-contrl"
                      >
                        {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                          <div>
                            <input
                              {...getInputProps({
                                placeholder: 'Buscar dirección...',
                                className: 'location-search-input form-control',
                              })}
                            />
                            <div className={"autocomplete-dropdown-container maps" + (suggestions && suggestions.length > 0 ? " active" : "")}>
                              {loading && <div><i className="now-ui-icons arrows-1_refresh-69 spin"/> Cargando...</div>}
                              {suggestions.map(suggestion => {
                                const className = suggestion.active
                                  ? 'suggestion-item active'
                                  : 'suggestion-item';
                                // inline style for demonstration purpose
                                // const style = suggestion.active
                                //   ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                //   : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                // console.log(suggestion);
                                let suggestion_locality = "";
                                if (suggestion.terms) {
                                  try {
                                    suggestion_locality = suggestion.terms[suggestion.terms.length - 2].value
                                  } catch (error) {
                                    console.log("Error retrieving locality 1:", error);
                                    try {
                                      suggestion_locality = suggestion.terms[suggestion.terms.length - 1].value;
                                    } catch (error) {
                                      console.log("Error retrieving locality 2:", error);
                                      suggestion_locality = "Error en la localidad";
                                    }
                                  }
                                }
                                return (
                                  <div key={suggestion.placeId}>
                                    <span className="suggestion-label">
                                      <h6>
                                        <i
                                          className="now-ui-icons location_pin"
                                          style={{ color: "#F00" }}
                                        />
                                        {" " + suggestion_locality}
                                      </h6>
                                    </span>
                                    <div
                                      {...getSuggestionItemProps(suggestion, {
                                        className
                                      })}
                                    >
                                      <span>{suggestion.formattedSuggestion.mainText}</span>
                                    </div>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                      <br />
                      {this.state.latitude && <Row>
                        <Col xs={12}>
                          <h6 className="category"><i className="now-ui-icons location_pin"/> Coordenadas</h6>
                        </Col>
                        <Col xs={6}>
                          <Input
                            type="text"
                            placeholder="Latitud"
                            value={this.state.latitude || ""}
                            onChange={e => this.setState({ latitude: e.target.value })}
                          />
                        </Col>
                        <Col xs={6}>
                          <Input
                            type="text"
                            placeholder="Longitud"
                            value={this.state.longitude || ""}
                            onChange={e => this.setState({ longitude: e.target.value })}
                          />
                        </Col>
                      </Row>}
                    </FormGroup>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            {this.state.latitude && <Row>
              <Col xs={12} md={6}>
                <Card>
                  <CardHeader>
                    <CardTitle tag="h4">Mapa</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <RegularMap
                      googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBqHety4jjWm2r747ZT8L-pUDDQqCLY05o"
                      loadingElement={<div style={{ height: "100%" }} />}
                      containerElement={<div style={{ height: "350px" }} />}
                      mapElement={<div style={{ height: "100%" }} />}
                      latitude={parseFloat(this.state.latitude)}
                      longitude={parseFloat(this.state.longitude)}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>}
            <Row>
              <Col xs={12} md={4}>
                  <CardTitle tag="h4">Detalles de la cita</CardTitle>
              </Col>
            </Row>
            <Row>
              <Col md={12} xs={12}>
                <Card>
                  <CardBody>
                    <Row>
                      <Col xs={12} md={6}>
                        <Row>
                          <Col xs={12} md={6}>
                            <CardTitle tag="h4">Tipo de cita</CardTitle>
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              placeholder="Seleccionar tipo"
                              name="visit_type"
                              value={this.state.visit_type}
                              options={this.props.mainState.homeVisitTypesList}
                              noOptionsMessage={() => "Cargando tipos"}
                              onChange={value =>
                                this.setState({ visit_type: value })
                              }
                            />
                          </Col>
                          <Col xs={12} md={6}>
                            <CardTitle tag="h4">Técnico</CardTitle>
                            <Select
                              className="react-select primary"
                              classNamePrefix="react-select"
                              isMulti
                              closeMenuOnSelect={false}
                              placeholder="Seleccionar técnicos"
                              name="technicians"
                              value={this.state.technicians}
                              options={this.props.mainState.techniciansList}
                              noOptionsMessage={() => "Cargando técnicos"}
                              onChange={value =>
                                this.setState({ technicians: value })
                              }
                            />
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={6}>
                        <CardTitle tag="h4">Título</CardTitle>
                        <FormGroup>
                          <Input
                            type="text"
                            placeholder="Cambiar cable"
                            value={this.state.title || ""}
                            onChange={e => this.setState({ title: e.target.value })}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <Col xs={12} md={6}>
                        <CardTitle tag="h4">Descripción</CardTitle>
                          <br />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            <Row>
              <Button
                color={"primary"}
                round 
                // icon 
                disabled={!this.validateNewHomeVisit()}
                onClick={() => {
                  if (this.state.isEdit) {
                    this.editHomeVisit();
                  } else {
                    this.createHomeVisit();
                  }
                }}
              >
                <i className={this.props.mainState.isCreatingHomeVisit?
                  "now-ui-icons arrows-1_refresh-69 spin reposition-spin" :"now-ui-icons ui-1_simple-add"} />
                {" " + save_text}
              </Button>
              {goBackButton}
            </Row>
          </div>
        </div>
      );
    }
  }
}

export default NewHomeVisit;



// WEBPACK FOOTER //
// ./src/views/HomeVisits/NewHomeVisit.jsx